import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

const ColorButton = styled(Button)((props) => {
  return ({
  color: '#fff',
  backgroundColor: '#000',
  textTransform: 'none',
  fontFamily: "LatoRegular",
  fontWeight: '600',
  '&:hover': {
    backgroundColor: grey['A700'],
  },
  height: '40px',
})});

export default function CustomizedButtons({ onClick, title, disabled }) {
  return (
    <ColorButton disabled={disabled} variant="contained" onClick={onClick}>{title}</ColorButton>
  );
}